import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as constants from "./constants";


const initialState = {...defaultInitialState};
const reducers = {...defaultReducers};

export const countriesSlice = createSlice({
  name: "countries",
  initialState,
  reducers,
});

